import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { SERVICE_UNAVAILABLE } from '../../actions/auth';
import { PAGE_URL } from '../../../utils/constants';
import { querySyncPush } from '../../actions/navigation';

export default action$ => action$.pipe(
  ofType(SERVICE_UNAVAILABLE),
  map(() => querySyncPush(PAGE_URL.SERVICE_UNAVAILABLE))
);